import { render } from "./EtatMpostBox.vue?vue&type=template&id=003ce977&ts=true"
import script from "./EtatMpostBox.vue?vue&type=script&lang=ts"
export * from "./EtatMpostBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__